import { State, MainThunkDispatch } from "../Reducers"
import { TrackingType } from "../Actions/Types"

export function LocationChangedActor() {
    let oldP: string | undefined
    return (state: State, dispatch: MainThunkDispatch) => {
        const p = state.client.routeInfo.pathname
        if (p && p.complete && oldP !== p.complete) {
            oldP = p.complete
            dispatch({ type: TrackingType.routeUpdated })
        }
    }
}
